import type { FC } from 'react';
import { useState } from 'react';

import Typography from 'components/Typography';

import { Icon } from 'pages/VerifyQuote/VerifyQuote.styled.ts';

import closeIcon from 'assets/close.svg';
import infoIcon from 'assets/info_bg.svg';

import {
  CloseButton,
  Tooltip,
  TooltipContainer,
  TooltipContent,
  TooltipWrapper,
} from './HoverTooltip.styled';
import type { HoverTooltipProps } from './HoverTooltip.types';

const HoverTooltip: FC<HoverTooltipProps> = ({
  content,
  title,
  position = 'top',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <TooltipWrapper>
      <Icon src={infoIcon} onClick={handleToggle} />
      <TooltipContainer $position={position} $isOpen={isOpen}>
        <TooltipContent>
          <Tooltip>
            <Typography
              style="semibold"
              type="Caption"
              children={title}
              color="#3D3D3D"
            />
            <Typography type="Caption" children={content} color="#3D3D3D" />
          </Tooltip>
          <CloseButton onClick={handleToggle} src={closeIcon} />
        </TooltipContent>
      </TooltipContainer>
    </TooltipWrapper>
  );
};

export default HoverTooltip;
